export const INIT_DIMENSIONS = {
  x: 512,
  y: 200,
}